import { useAddCommandBarStateValue } from '../command-bar-context.js';

/**
 * Hook to set a custom placeholder for the command bar input.
 * The last registered placeholder wins, allowing page-specific customization.
 *
 * @param text - The placeholder text to display
 * @example
 * ```tsx
 * function MyComponent() {
 *   useRegisterCommandBarPlaceholder('Enter a reference designator to search modules');
 *   return <div>My Component</div>;
 * }
 * ```
 */
export function useRegisterCommandBarPlaceholder(text: string) {
	useAddCommandBarStateValue('placeholder', text);
}
